import { createAction } from '@reduxjs/toolkit';

import { FORM_MODE } from '@savgroup-front-common/constants';

import { CREATE_USER_MANAGEMENT } from './actionTypes';
import { UserRoleOrUserPermission } from './types';

export interface SetUserPayload {
  userId: string;
  lastname: string;
  firstname: string;
  email: string;
  credentials: UserRoleOrUserPermission[];
  type: FORM_MODE;
}
export const setUserActionCreator = createAction<SetUserPayload>(
  CREATE_USER_MANAGEMENT.SUCCEEDED,
);

export interface SetUserProfilePayload {
  userProfileId: string;
  name: string;
  tenantId?: string;
  roleIds: string[];
  cumulDashboardIds: string[];
  permissions: string[];
}

export interface GetUserProfilesPayload {
  tenantId: string;
}
